<script>
  const cautions = `이용시 참고사항

공간대여 이용은 선불제로 운영하고 있습니다.
예약 확정 문자를 꼭 ! 확인해 주세요.
이용 중 시간 추가는 별도 문의 바랍니다.
다음 팀의 원활한 사용을 위해 사용하신 물품은 원래의 상태로 복구 부탁 드립니다.
식사나 음료는 가능하나 소품이 오염 안되게 조심해 주세요.(오염시 변상)
미성년자의 출입을 금하며, 본 시설 내 불법적 행위는 금지합니다.(적발 시 환불없이 즉각퇴실)





`;
</script>

<article class="infos">
  <header class="info-title">* 참고 및 주의사항</header>
  <ul class="list-1 dashed">
    <li class="item">공간대여 이용은 선불제로 운영하고 있습니다.</li>
    <li class="item">예약 확정 문자를 꼭 ! 확인해 주세요.</li>
    <li class="item">이용 중 시간 추가는 별도 문의 바랍니다.</li>
    <li class="item">
      다음 팀의 원활한 사용을 위해 사용하신 물품은 원래의 상태로 복구 부탁
      드립니다.
    </li>
    <li class="item">
      식사나 음료는 가능하나 소품이 오염 안되게 조심해 주세요.(오염시 변상)
    </li>
    <li class="item">
      미성년자의 출입을 금하며, 본 시설 내 불법적 행위는 금지합니다.(적발 시
      환불없이 즉각퇴실)
    </li>
  </ul>
  <br />
  <ul class="list-2 dashed">
    <li>24시간 CCTV가 가동 중 입니다.</li>
    <li>(범죄, 화재 예방 및 고객 안전 및 시설보호)</li>
    <li>악기 및 카메라는 별도로 준비해주세요.</li>
    <li>
      배달음식 취식 후 분리수거 부탁드립니다.(캔, 플라스틱,일반쓰레기,음식물
      구분)
    </li>
    <li>
      분실물을 보관하지 않습니다. 퇴실 후 당일 문의시에만 확인 가능합니다.
    </li>
    <li>실내에서는 금연입니다. (전자담배 포함)</li>
  </ul>
  <br />
  <ul class="list-3 dashed">
    <li>
      입실 & 퇴실 시간을 잘 지켜 주시고, 협의되지 않은 퇴실 지연은 30분당 1만원
      청구 됩니다.
    </li>
    <li>청소&정리 없이 퇴실 시 - 3만원 청구 및 이용제한</li>
    <li>분리수거 없이 나가신 경우 - 2만원 청구</li>
    <li>
      그 외 - 실비처리(청소 업체 및 외부 용역업체 이용시) 및 휴업손해비용 청구
    </li>
  </ul>
  <br />
  <header class="info-title">* 환불 규정</header>
  <ul class="list-4 dashed">
    <li>이용 3일전 100% 환불</li>
    <li>이용 2일전 80% 환불</li>
    <li>이용 전날 50% 환불</li>
    <li>이용 당일 환불 불가</li>
  </ul>
</article>

<style>
  .infos {
    width: 60%;
    margin: 0 auto;
    font-size: 20px;
    font-weight: 100;
  }

  .info-title {
    margin-bottom: 10px;
    font-weight: 500;
  }
  .list-1,
  .list-4 {
    font-weight: 200;
  }
  ul {
    margin: 0;
    padding: 0;
  }
  ul.dashed {
    list-style-type: none;
  }
  ul.dashed > li {
    /* text-indent: -5px; */
    /* margin: 0; */
    margin-bottom: 4px;
    word-break: keep-all;
  }
  ul.dashed > li:before {
    content: '-';
    /* text-indent: -5px; */
  }

  @media screen and (max-width: 768px) {
    .infos {
      width: 100%;
      font-size: 18px;
    }
  }
</style>
